var map = {
	"./Arte.svg": "cd9b",
	"./Autoayuda.svg": "c8fa",
	"./Aventura.svg": "f3d6",
	"./Ciencia Ficción.svg": "953b",
	"./Ciencia y Tecnología.svg": "f125",
	"./Comic.svg": "355d",
	"./Crimen y Policial.svg": "9e0d",
	"./Cultura.svg": "172e",
	"./Deportes.svg": "9397",
	"./Drama.svg": "2cac",
	"./Educación.svg": "a6fa",
	"./Espiritualidad.svg": "38ee",
	"./Fantástico.svg": "a6f6",
	"./Fomento Lector.svg": "d906",
	"./Gastronomía.svg": "f5d7",
	"./Historia y Filosofía.svg": "c890",
	"./Infantil.svg": "e0f1",
	"./Maravilloso.svg": "4e5f",
	"./Medioambiente.svg": "001f",
	"./Misterio y suspenso.svg": "0ee3",
	"./Mitos y Leyendas.svg": "6a7c",
	"./Música.svg": "a36f",
	"./Ocio.svg": "88ee",
	"./Poesía.svg": "e1e8",
	"./Romance.svg": "d318",
	"./Teatro.svg": "feef",
	"./Terror.svg": "b877",
	"./Vida y Salud.svg": "dca1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "385e";